var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-self-center"},[_c('button',{staticClass:"btn btn-sm btn-link mt-auto",on:{"click":_vm.handleSkip}},[_vm._v(" Sauter ces étapes pour le moment ")])])}
var staticRenderFns = []

export { render, staticRenderFns }